import { FaCaretRight, FaPlus } from "react-icons/fa";

import { TokenPoints } from "@bentolabs/points-worker";
import { useChainId } from "wagmi";

import Etherscan from "shared/assets/etherscan.svg?react";
import { tokensMeta } from "shared/config/tokens";
import { useResponsive } from "shared/hooks/use-responsive";
import { Button } from "shared/ui/button";
import { Img } from "shared/ui/img";
import { getBlockExplorerLink } from "shared/web3/utils/get-block-explorer-link";

import { RowMobile } from "./row-mobile";

type Props = {
  pool: TokenPoints;
};

const formatter = new Intl.NumberFormat("en-US", {
  notation: "compact",
});

export const Row = (props: Props) => {
  const { pool } = props;
  const chainId = useChainId();
  const { sm } = useResponsive();

  const meta = tokensMeta[pool.token.symbol];

  const tokenLink = `${getBlockExplorerLink(chainId)}/token/${pool.token.address}`;

  if (!sm) return <RowMobile pool={pool} />;

  return (
    <div className="bg-baltic-sea/30 grid grid-cols-[2fr_1.5fr_1fr_1fr_1fr_0.5fr] items-center rounded-[10px] p-3">
      <div className="flex items-center gap-x-3.5">
        <Img className="size-9" src={meta?.logoURI} alt={pool.token.symbol} />
        <div className="flex flex-col">
          <div className="leading leading-none capitalize">
            {pool.token.name}
          </div>
          <div className="text-nobel/70 mt-1 w-50 overflow-hidden text-sm leading-[150%] text-ellipsis whitespace-nowrap capitalize">
            {pool.token.description}
          </div>
        </div>
      </div>

      <div>{formatter.format(pool.balance)}</div>

      <div>{formatter.format(pool.points.value)}</div>
      <div>{formatter.format(pool.points.rate * 86400)}</div>

      <div className="justify-self-start">
        <Button variant="spearmint/10">
          <FaPlus className="size-3" /> Deposit
        </Button>
      </div>

      <div className="justify-self-end">
        <Button
          as="a"
          target="_blank"
          href={tokenLink}
          variant="nobel/10"
          className="gap-1.5 px-2.5"
        >
          <Etherscan className="size-3" />
          <FaCaretRight className="size-3.5" />
        </Button>
      </div>
    </div>
  );
};
